import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Card from "../Card/Card";
import CardBody from "../Card/CardBody.js";
import CardHeader from "../Card/CardHeader.js";

import styles from "../../../assets/jss/material-dashboard-react/components/customTabsStyle.js";

import { IconButton, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Modal_Frame from "../Modal_Frame";
// import CreateActivities from "../../crm/Activities/CreateActivities";
// import CreateNotes from "../../crm/Activities/CreateNotes";
import UseFetchData from "../../../hooks/UseFetchData";

const useStyles = makeStyles(styles);

export default function CustomTabs(props) {
  const [value, setValue] = React.useState(0);
  const [isOpen, setOpen] = useState(false);
  const [OpenModel, setOpenModel] = useState(false);
  const [UserID,setUserID] = useState(sessionStorage.UID);
  const [responseDtls, fetchDtlsData] = UseFetchData();

  const handleChange = (event, value) => {
    setValue(value);
  };

  const classes = useStyles();
  const { headerColor, plainTabs, tabs, title, rtlActive } = props;

  const cardTitle = classNames({
    [classes.cardTitle]: true,
    [classes.cardTitleRTL]: rtlActive,
  });

  const AddNewClick = () => {
    debugger;
    //console.log(value);
    if (value === 0) {
      setOpen(true);
    }
    else if (value === 1) {
      setOpenModel(true);
    }
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", UserID);
    bodyFormData.append("FinacialDate", '');
    bodyFormData.append("FromDate", '');
    bodyFormData.append("ToDate", '');
    fetchDtlsData("Dashboard/View", bodyFormData);
  }

  return (
    <Card plain={plainTabs}>
      <CardHeader color={headerColor} plain={plainTabs}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {title !== undefined ? <div className={cardTitle}>{title}</div> : null}
          <Tabs
            value={value}
            onChange={handleChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.displayNone,
              scrollButtons: classes.displayNone,
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((prop, key) => {
              var icon = {};
              if (prop.tabIcon) {
                icon = {
                  icon: <prop.tabIcon />,
                };
              }
              return (
                <Tab
                  classes={{
                    root: classes.tabRootButton,
                    selected: classes.tabSelected,
                    wrapper: classes.tabWrapper,
                  }}
                  key={key}
                  label={prop.tabName}
                  {...icon}
                />
              );
            })}
          </Tabs>
          <div style={{ width: '50%' }}>
            <div style={{ float: 'right' }}>
              <Tooltip title="Add New">
                <IconButton onClick={() => { AddNewClick(); }} >
                  <AddCircleOutlineIcon style={{ fill: 'white' }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <div style={{ overflow: 'scroll', overflowX: 'hidden', height: 375 }} >
          {tabs.map((prop, key) => {
            if (key === value) {
              return <div key={key}>{prop.tabContent}</div>;
            }
            return null;
          })}
        </div>
      </CardBody>
      {/* <Modal_Frame
        title="Activity Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateActivities
          setOpen={setOpen}
          DisableUpdate={false}
          DisableComplete={false}
          DisableDelete={true}
          RefDocumentID={UserID}
          PopulateData={PopulateData}
          DisableCustomer={false}
          DisableContact={false}
          DisableRefDoc={false}
        />
      </Modal_Frame> */}

      {/* <Modal_Frame
        title="Note Details"
        maxWidth="xs"
        isOpen={OpenModel}
        setOpen={setOpenModel}
      >
        <CreateNotes
          setNoteOpen={setOpenModel}
          RefDocumentID={UserID}
          NoteID=""
          PopulateData={PopulateData}
        />
      </Modal_Frame> */}
    </Card>
  );
}

CustomTabs.propTypes = {
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node.isRequired,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
};
